import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { colors, styles, spacing } = theme.busbud;
  const { borderWidth, rounding } = styles;

  // [*] TODO: consider to remove this because component should be position and layout agnostic

  return {
    layout: {
      border: `${borderWidth.md} solid ${colors.border.secondary.transparent}`,
      padding: spacing(2),
      backgroundColor: colors.palette.static.white
    },
    left: {
      position: "relative",
      overflowX: "auto",
      marginRight: spacing(2), // [*]
      borderRadius: `${rounding.xl} ${rounding.lg} ${rounding.lg} ${rounding.xl}`
    },
    top: {
      marginBottom: spacing(2), // [*]
      borderRadius: `${rounding.xl} ${rounding.xl} ${rounding.lg} ${rounding.lg}`
    }
  };
});
